module.exports = __webpack_public_path__ + "img/badge-top-work-places.29e49592.png";